export default identifier => `
  {
    filterPage(identifier: "${identifier}") {
      imageUrl
      mobileImageUrl
      explodeVariants

      topBanner {
        title
        ctaText
        ctaTarget
        item {
          id
          name
          summary
          price

          variants {
            id
            isBackorderable
            colorName
            productUrl
            imageUrl
            backgroundImageUrl
            backgroundVideoUrl
            colorCodePrimary
            colorCodeSecondary
            skus
            spreeProduct
            availabilityDate
            filterValues
            soldItems
          }
        }
      }

      promoCards {
        id
        isPromoCard
        productGroup
        variant
        text
        ctaText
        targetUrl
        imageUrl
        videoUrl
      }

      featuredArticles {
        title
        categoryLink
        articles {
          title
          thumbUrl
          articleUrl
        }
      }

      subPages {
        title
        description
        filterValues
        imageUrl
        mobileImageUrl
        metaTitle
        metaDescription
      }

      filters {
        id
        title
        order
        level
        type
        values
        excludeIf
        includedInPath
      }

      items {
        id
        name
        summary
        mainVariantId
        price
        filterValues

        variants {
          id
          isBackorderable
          colorName
          productUrl
          imageUrl
          backgroundImageUrl
          backgroundVideoUrl
          colorCodePrimary
          colorCodeSecondary
          skus
          spreeProduct
          availabilityDate
          filterValues
          soldItems
        }
      }
    }
  }
`
